import { Component, OnInit } from '@angular/core';

interface Job {
  Tab: string;
  Title: string;
  Date: string;
  Description: string[];
}

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent implements OnInit {

  active = 0;
  jobs: Job[] = [
    {
      "Tab": "Ajapro",
      "Title": "Full Stack Developer",
      "Date": "March 2023 - Present",
      "Description": [
        "Developing and maintaining a web-based application using Angular, Node.js, and MongoDB, resulting in improving user experience and increasing performance.",
        "Designing and implementing RESTful APIs to support multiple applications, using Node.js and Express.",
        "Collaborating with the client to gather and document ongoing project requirements.",
        "Continuously developing responsive user interfaces using Angular, aligning with Figma UI designs.",
        "Ongoing integration of APIs to facilitate data exchange and enhance user interactions.",
        "Implementing user permissions and restrictions using CASL (Code Access Security Language).",
        "Developing APIs using Objection.js ORM (Object-Relational Mapping) and Express.js framework for efficient data handling.",
        "Managing database operations, including migrations and seeds, using Knex.js to ensure proper schema changes and data seeding.",
        "Writing queries using the query builder provided by Knex.js for efficient and standardized database interactions.",
        "Performing regular and thorough quality assurance (QA) testing to maintain and enhance product functionality and reliability."
      ]
    },
    {
      "Tab": "Pantech",
      "Title": "Data Analytics Intern",
      "Date": "May 2022 - February 2023",
      "Description": [
        "Assist in collecting, organizing, and preprocessing data for analysis to ensure data quality.",
        "Perform basic data analysis and generate reports to support decision-making.",
        "Create data visualizations and dashboards to present insights effectively.",
        "Collaborate with team members to understand and meet data requirements.",
        "Apply basic statistical techniques for data analysis to derive meaningful conclusions.",
        "Document data analysis processes and findings to maintain clear records.",
        "Research and implement data analytics best practices to improve workflows.",
        "Work on small data projects to gain practical experience and enhance skills.",
        "Participate in team meetings and discussions to contribute ideas and insights.",
        "Demonstrate a willingness to learn and adapt to new tools and technologies."
      ]
    },
    {
      "Tab": "Raster",
      "Title": "Jr.Architect",
      "Date": "August 2021 - March 2022",
      "Description": [
        "Produce detailed architectural plans, elevations, and sections in accordance with architectural scans.",
        "Create precise technical drawings for interiors and woodworks, ensuring accuracy and adherence to project specifications.",
        "Initiate information requests to clients when necessary, ensuring comprehensive project understanding.",
        "Maintain regular communication and follow-ups with Team Leader to track project progress.",
        "Submit timely and accurate reports to Team Leader, ensuring transparency and effective project management.",
        "Collaborate seamlessly within a team, fostering teamwork and coordination for efficient project execution.",
        "Demonstrate a commitment to accuracy by providing precise drawings to clients.",
        "Actively participate in office and client meetings, contributing valuable insights and updates.",
        "Manage project timelines effectively, striving to complete projects on or before delivery deadlines."
      ]
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }
}
